import styled from 'styled-components';
import { MIN_CARD_WIDTH } from '@/components/AdCard/AdCard.constants';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Title = styled.div`
  padding: 20px 15px 5px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const AdCardsBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${MIN_CARD_WIDTH}px, 1fr));
  justify-content: center;
  gap: 10px 9px;
  padding: 15px;
`;

export const MoreBottomBox = styled.div`
  padding: 5px 15px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;
